import React, { useEffect, useState } from "react";
import SalaryManagementPage from "../../../../../entities/DashboardPage/HRModule/SalaryManagementPage/View";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";
import { salaryService } from "../../../../../api";
import { getBlobErrorMessage } from "../../../../../utils/blobError";
// import { useNavigate } from "react-router-dom";

// eslint-disable-next-line import/default
// import LoaderHelper from "../../../utils/Loader/LoaderHelper";

const SalaryManagement = () => {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState();
  const [loader, setLoader] = useState();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [dataAll, setDataAll] = useState([]);
  const [count, setCount] = useState();
  const [page, setPage] = useState(1);
  const [permission, setPermission] = useState(null);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");
  const [departmentData, setDepartmentData] = useState([]);
  const [empData, setempData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [depData, setDepData] = useState([]);
  const [popupMsg, setPopupMsg] = useState("");
  const [holidayOpen, setHolidayOpen] = useState(false);
  const [isProcessed, setIsProcessed] = useState(null);
  const [isPayslipAccessDisabled, setIsPayslipAccessDisabled] = useState(false);
  const { state } = useLocation();
  const { item } = state || {};
  const isEmployeeRole = role === "Employee" || role === "employee";

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    if (isEmployeeRole) {
      checkPayslipAccess();
    }

    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };

    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  // Employee-only, UX affordance only (not a security control - see
  // CLAUDE.md §21). Hides payslip download/print once the employee has been
  // deactivated, or - for contractor-type employees - once their contract
  // end date has passed. Real enforcement, if any, happens server-side.
  const checkPayslipAccess = async () => {
    try {
      const result = await AuthService.getProfileView();
      const profile = result?.data;
      if (!profile) return;
      const isRemoved = profile?.isActive === false;
      const empType = profile?.additionalInformation?.empType;
      const contractEnd = profile?.additionalInformation?.contractor?.end;
      const isContractExpired =
        empType === "contractor" && !!contractEnd && new Date(contractEnd).getTime() < Date.now();
      setIsPayslipAccessDisabled(isRemoved || isContractExpired);
    } catch (error) {
      // Cannot determine status - fail open (UX only, see note above).
    }
  };

  useEffect(() => {
    if (permission !== null || role !== "Employee" && role !== "employee") {
      getSalaryList("", "", page);
      getAllDepartmentList();
      getDepartment();
    }
  }, [page, permission])

  const getSalaryList = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSalaryList(text, sort, page, item?.startDate, item?.endDate);
      if (result?.success) {
        let salaries = result?.data?.salaries || [];

        // Filter data based on permissions for Employee role
        if ((role === "Employee" || role === "employee") && employeeId && permission) {
          const hasViewPermission = permission?.salary?.isView === true;
          const hasEditPermission = permission?.salary?.isEdit === true;

          // If employee has edit permission, show all salaries (like admin)
          if (hasEditPermission) {
            setCount(result?.data?.total);
          } else if (hasViewPermission) {
            salaries = salaries.filter(
              (sal) =>
                sal?.employee === employeeId ||
                sal?.employee?._id === employeeId ||
                sal?.employee?.userId === employeeId
            );
            setCount(salaries.length);
          } else {
            // No view permission, show nothing
            salaries = [];
            setCount(0);
          }
        } else {
          setCount(result?.data?.total);
        }

        setData(salaries);
        setFilteredData(salaries);
        setDataAll(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleSearch = (text, sort) => {
    text ? getSalaryList(text) : sort ? getSalaryList("", sort) : null
  }

  const handleUpdate = async (paid, id) => {
    try {
      const result = await AuthService.handlePayslip(id, "", paid);
      if (result?.success === true) {
        showAlert(result?.message, "success");
      } else {
        showAlert(result?.message, "error");
      }
    } catch (error) {
      showAlert(error, "error");
    }
  };

  const handleProcessAll = async () => {
    try {
      const result = await AuthService.handleProcessAll(item?.startDate, item?.endDate);
      if (result?.success === true) {
        setIsProcessed(result?.success)
        showAlert(result?.message, "success");
        getSalaryList();
      } else {
        showAlert(result?.message, "error");
        setIsProcessed(result?.success)
      }
    } catch (error) {
      showAlert(error, "error");
    }
  };

  const getAllDepartmentList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllDepartmentList();
      if (result?.success) {
        setempData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getDepartment = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDepartment();
      if (result?.success) {
        setDepartmentData(result?.data?.position);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const SearchEmployee = async (text) => {
    setLoading(true);
    if (!text) {
      setLoading(false);
      return;
    }
    try {
      const result = await AuthService.getEmployeeList(text);
      if (result?.success) {
        setEmployeeData(result?.data?.employees);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const DepartmentPayroll = async (department) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handlePayrollDepartmemt(department);
      if (result?.success) {
        const employees = Array.isArray(result?.data)
          ? result.data
          : Array.isArray(result?.data?.data)
            ? result.data.data
            : [];
        setDepData(employees);
        LoaderHelper.loaderStatus(false);
      } else {
        setDepData([]);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      setDepData([]);
      LoaderHelper.loaderStatus(false);
    }
  };

  // ------------------------------------------------------------------------
  // Add bonus
  // ------------------------------------------------------------------------

  const handleBonus = async (employees, bonus, date, to, fixed, bonusName, percentageType) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await salaryService.addBonus(employees, bonus, date, to, fixed, bonusName, percentageType);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        getSalaryList("", "", page);
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  const handleDate = async (date, to) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await salaryService.BonusDate(date, to);
      if (result?.success && result.data.isAffectOldSalaries === true) {
        setPopupMsg("Selected date range may affect the old payrolls");
        setHolidayOpen(true);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      setHolidayOpen(false);
    }
  }
  // ------------------------------------------------------------------------
  // Get payslip as Pdf
  // ------------------------------------------------------------------------

  const payslipPDF = async (payslipId) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await salaryService.payslipPDF(payslipId);
      LoaderHelper.loaderStatus(false);
      const downloadError = await getBlobErrorMessage(result);
      if (downloadError) {
        LoaderHelper.loaderStatus(false);
        showAlert(downloadError, "error");
        return;
      }
      const blob = new Blob([result], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      return url
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message, "error");
    }
  }

  const handlePrintAll = async () => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handlePrintAll(item?.startDate, item?.endDate);

      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const downloadError = await getBlobErrorMessage(result);
        if (downloadError) {
          setLoading(false);
          LoaderHelper.loaderStatus(false);
          showAlert(downloadError, "error");
          return;
        }
        const blob = new Blob([result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${"pdf"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleEmailAll = async () => {
    LoaderHelper.loaderStatus(true);
    setLoader(true);

    try {
      const result = await AuthService.handleEmailAll(item?.startDate, item?.endDate);
      if (result?.success === true) {
        showAlert(result?.message, "success");
        setLoader(false);
        LoaderHelper.loaderStatus(false);

      } else {
        showAlert(result?.message, "error");
        setLoader(false);
        LoaderHelper.loaderStatus(false);

      }
    } catch (error) {
      showAlert(error, "error");
    }
  };

  const handleShowPdf = async (id) => {
    const result = await salaryService.showPdf(id);
    return { __html: result };
  };

  return (
    <SalaryManagementPage count={count} page={page} setPage={setPage} data={filteredData.length > 0 ? filteredData : data} permission={permission} role={role}
      handleSearch={handleSearch} handleUpdate={handleUpdate} handleProcessAll={handleProcessAll}
      handlePrintAll={handlePrintAll} handleEmailAll={handleEmailAll} loading={loading} loader={loader}
      dataAll={dataAll} employeeData={employeeData} handleBonus={handleBonus} payslipPDF={payslipPDF} isProcessed={isProcessed}
      DepartmentPayroll={DepartmentPayroll} depData={depData} SearchEmployee={SearchEmployee} departmentData={departmentData} empData={empData}
      handleDate={handleDate} popupMsg={popupMsg} holidayOpen={holidayOpen} setHolidayOpen={setHolidayOpen} handleShowPdf={handleShowPdf}
      isPayslipAccessDisabled={isPayslipAccessDisabled} />
  )

}

export default SalaryManagement;
